import { createFileRoute, redirect } from '@tanstack/react-router'

/** /platform: the console opens on its dashboard. */
export const Route = createFileRoute('/platform/_console/')({
  beforeLoad: () => {
    throw redirect({ to: '/platform/dashboard', replace: true })
  },
})
